// OVERARCHING FILE TODOS:
// TODO: Loading failures are not handled properly.

import {Unity, useUnityContext, UnityConfig} from "react-unity-webgl";
import {UnityProvider} from "react-unity-webgl/distribution/types/unity-provider";
import {ReactUnityEventParameter} from "react-unity-webgl/distribution/types/react-unity-event-parameters";
import { CSSProperties, ReactNode, useDebugValue, useEffect, useState } from "react";


export enum gameIds{
    INSOMNIAC_MOLES = "GAME-INSOMNIAC_MOLES",
}

interface GameSegmentProps{
    gameId: string;
}

// TODO: Extend this.
type LoadableGameMetadata = {
    gameName: string;
    gameFilePath: string;
}

interface PreventWrapProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

// TODO: Put in another file for CORE components.
const PreventWrap: React.FC<PreventWrapProps> = ({ children, className, style }) => {
  return (
    <span
      className={className}
      style={{ whiteSpace: 'nowrap', ...style }}
    >
      {children}
    </span>
  );
};

const GameSegment = ({gameId}: GameSegmentProps) => {
    /*let [currUnityProvider, currIsLoaded, currLoadingProgression, currSendMessage, currAddEventListener, currRemoveEventListener, currInitialisationError]:
        [null | UnityProvider,
            boolean,
            number,
                null | ((gameObjectName: string, methodName: string, parameter?: ReactUnityEventParameter) => void),
                null | ((eventName: string, callback: (...parameters: ReactUnityEventParameter[]) => ReactUnityEventParameter) => void),
                null | ((eventName: string, callback: (...parameters: ReactUnityEventParameter[]) => ReactUnityEventParameter) => void),
                null | Error,
        ]
        = [
        null, false, 0, null, null, null, null,
    ];*/

    // const insomniacMolesDirectory = "/Game Datas/Insomniac Moles/Build/";  // TODO: Move these to some external file of constants, like an .env file. Or whatever fits.

    const useVersion = () =>{
        const [version, setVersion] = useState("Pending...");  // IF version starts with "", this will cause a CORS error somewhy??
        useDebugValue(version, v => v);
        return {version, setVersion};
    }
    const useGenericFailedToLoadMessage = () =>{
        const [genericFailedToLoadMessage, setGenericFailedToLoadMessage] = useState<string | null>(null);  // IF version starts with "", this will cause a CORS error somewhy??
        useDebugValue(genericFailedToLoadMessage, m => m);
        return {genericFailedToLoadMessage, setGenericFailedToLoadMessage};
    }

    const {version, setVersion} = useVersion();
    const {genericFailedToLoadMessage, setGenericFailedToLoadMessage} = useGenericFailedToLoadMessage();
    // const insomniacMolesFileName = "Build WebGL";  // TODO: Validate that this path exists for all 5 files
    /*useEffect(() => {
        fetch(insomniacMolesDirectory + insomniacMolesFileName + ".version.json")
            .then((response) => response.json())
            .then((data) => setVersion(data.version));
    }, []);*/

    // TODO
    const GetUnityGameMetadataGeneric: (targetGameId: string) => LoadableGameMetadata | null
        = (targetGameId: string) => {
            let resultGameData: LoadableGameMetadata | null = null;

            switch (targetGameId) {
                case gameIds.INSOMNIAC_MOLES:
                    resultGameData = {
                        gameName: "Insomniac Moles",
                        //gameFilePath: "/Game Datas/Insomniac Moles/Build/Build WebGL",
                        gameFilePath: "https://blawnode-game-build-files.s3.us-east-1.amazonaws.com/Build/Insomniac+Moles",
                    };
                    break;

                default:
                    // TODO: What if there's an error here?
                    console.error(`The game ${targetGameId} is currently not supported! Finish programming this.`);
            }

            return resultGameData;
        }

    const GetUnityGameMetadata: () => LoadableGameMetadata | null
        = () => GetUnityGameMetadataGeneric(gameId);
    
    function GetUnityGameVersion(gameFilePath?: string){
        useEffect(() => {
            if(!gameFilePath) {
                setGenericFailedToLoadMessage("Game metadata is missing. Version file not fetched.");
                return;
            }
            fetch(gameFilePath + ".version.json")
                .then((response) => response.json())
                .then((data) => {setVersion(data.version); console.log("Version file .json:"); console.log(data)})
                .catch((e) => setGenericFailedToLoadMessage(!gameFilePath ? "Failed to fetch version file: " : (e as Error).message));
        }, [gameFilePath]);
    }

    /*const [unityProvider, isLoaded, loadingProgression, sendMessage, addEventListener, removeEventListener, initialisationError,]:
        [null | UnityProvider,
            boolean,
            number,
                null | ((gameObjectName: string, methodName: string, parameter?: ReactUnityEventParameter) => void),
                null | ((eventName: string, callback: (...parameters: ReactUnityEventParameter[]) => ReactUnityEventParameter) => void),
                null | ((eventName: string, callback: (...parameters: ReactUnityEventParameter[]) => ReactUnityEventParameter) => void),
                null | Error,
        ]
        = [
        null, false, 0, null, null, null, null,
    ];*/  // Better to not type them like that, maybe. Better to not pre-declare them, due to the nature of hooks.

    function useLoadUnityGame(gameFilePath?: string, version?: string) {
        let dontLoadUnityFiles = !(gameFilePath && version);
        
        let { unityProvider, isLoaded, loadingProgression, sendMessage, addEventListener, removeEventListener, initialisationError }
            = useUnityContext({
                loaderUrl: dontLoadUnityFiles ? gameFilePath + ".loader.js" + `?v=${version}` : "",
                dataUrl: dontLoadUnityFiles ? gameFilePath + ".data" + `?v=${version}` : "",
                frameworkUrl: dontLoadUnityFiles ? gameFilePath + ".framework.js" + `?v=${version}` : "",
                codeUrl: dontLoadUnityFiles ? gameFilePath + ".wasm" + `?v=${version}` : "",
            } as UnityConfig);
           
        /*initialisationError = !gameFilePath
            ? new Error("Game metadata is missing. Unity files not loaded.")
            : initialisationError;*/

        return { unityProvider, isLoaded, loadingProgression, sendMessage, addEventListener, removeEventListener, initialisationError };
    }

    //  Hooks must be called on a function's root level. No conditional hooks.

    let gameMetadata: LoadableGameMetadata | null = null;
    gameMetadata = GetUnityGameMetadata();
    let gameFilePath = gameMetadata?.gameFilePath;
    GetUnityGameVersion(gameFilePath);  // TODO: After fixing on local, do this.
    const { unityProvider, isLoaded, loadingProgression, sendMessage, addEventListener, removeEventListener, initialisationError }
                = useLoadUnityGame(gameFilePath, (version && version !== "Pending...") ? version : undefined);

    // Watch for initialization or manual errors.
    useEffect(() => {
        if(!gameFilePath)
        {
            let msg = "Game metadata is missing. Unity files not loaded.";
            console.error(msg);
            setGenericFailedToLoadMessage(msg);
        }
        else if(version === ""){
            let msg = "Version couldn't be fetched. Unity files not loaded.";
            console.error(msg);
            setGenericFailedToLoadMessage(msg);
        }
        else if (initialisationError) {
            console.error("Unity game failed to initialize:", initialisationError);
            setGenericFailedToLoadMessage(initialisationError.message);
        }
    }, [initialisationError]);

    // Can't be detected, because initialisationError is async.
    /*if(initialisationError){
        throw initialisationError;
    }*/
    
    /*catch(e){
        let msg = (e as Error).message;
        setGenericFailedToLoadMessage(msg);
        console.warn(msg);
    }*/

    // sendMessage = (gameObjectName: string, methodName: string) => {console.log("1110");};
    // addEventListener = (gameObjectName: string, callback: (...parameters: ReactUnityEventParameter[]) => ReactUnityEventParameter) => {console.log("2220");};
    // removeEventListener = (gameObjectName: string, callback: (...parameters: ReactUnityEventParameter[]) => ReactUnityEventParameter) => {console.log("3330");};

    let gameLoadingInt = Math.round(loadingProgression * 100);
    let isGameFullyLoaded = gameLoadingInt == 100;  // TODO: Can't I just use isLoaded? Also, use this variable.

    return <div>
        {unityProvider &&
            <div style={{ paddingTop: "10vh", }}>
                <Unity unityProvider={unityProvider}
                    style={{ width: gameLoadingInt < 100 ? 0 : "50vh", height: gameLoadingInt < 100 ? 0 : "50vh",
                    aspectRatio: "auto 1 / 1", imageRendering: "pixelated",}} />
            </div>}
        
        {!genericFailedToLoadMessage && unityProvider && gameLoadingInt < 100 &&
            <div style={{display: "flex", flexDirection: "column",
                justifyContent: "center", alignItems: "center",
            }}>
                <div style={{ width: "50vh", height: "50vh",
                    display: "flex", flexDirection: "column",
                    justifyContent: "center", alignItems: "center",
                }}>
                    <img src="/Blawnode_Logo_MAX.png" className="App-logo" alt="logo"
                    style={{height: "8vmin",}}/>
                    <span>{gameLoadingInt}%</span>
                </div>
            </div>}

        {/*{(currUnityProvider && isGameFullyLoaded) &&
            <div className="gameProvidedAND100" style={{
                width: `${Math.round(currLoadingProgression * 100)}%`,
                height: "4px",
                backgroundColor: "#f448",
            }} />}
        {(!currUnityProvider && isGameFullyLoaded) &&
            <div className="gameNotProvidedAND100" style={{
                width: `${Math.round(currLoadingProgression * 100)}%`,
                height: "4px",
                backgroundColor: "#4f48",
            }} />}
        {isGameFullyLoaded &&
            <div className="game100" style={{
                width: `${Math.round(currLoadingProgression * 100)}%`,
                height: "4px",
                backgroundColor: "#44f8",
            }} />}*/}
        {!unityProvider && <h2>WARNING: The game <PreventWrap>{gameId}</PreventWrap> could not be loaded.</h2>}
        {/* TODO: For both of these arrows ^ V, add the X_EYES logo just like in the genericFailedToLoadMessage handling below. */}
        {initialisationError !== null && <h4>WARNING: Detected an initialization error for the game <PreventWrap>{gameId}</PreventWrap>:
            <br /><br />
            <span style={{ fontSize: "100%", }}>{initialisationError.message}</span></h4>}
        
        {genericFailedToLoadMessage &&
            <div style={{
                display: "flex", flexDirection: "column",
                justifyContent: "center", alignItems: "center",
            }}>
                <div style={{
                    width: "50vh", height: "50vh",
                    display: "flex", flexDirection: "column",
                    justifyContent: "center", alignItems: "center",
                }}>
                    <img src="/Blawnode_Logo_MAX_X_EYES.png" alt="failed-to-load-logo"
                        style={{ height: "8vmin", }} />
                    <h4>WARNING: Detected an initialization error for the game <PreventWrap>{gameId}</PreventWrap>:
                        <br /><br />
                        <span style={{ fontSize: "100%", }}>{genericFailedToLoadMessage}</span></h4>
                </div>
            </div>}

        <br />

        {unityProvider &&
            <div>
                {/*TODO: (Full game HTML metadata and description goes here.)*/}
                <h2>{gameMetadata?.gameName}</h2>
                Developers: Blawnode, redsti
                <p>Controls: Numpad / QWEASDZXC / Phone Taps</p>
            </div>
        }
    </div>;
};

export default GameSegment;